import { componentName } from "#color-mode-options";
export default {
  name: componentName,
  functional: true,
  props: {
    placeholder: String,
    tag: {
      type: String,
      default: "span"
    }
  },
  render(createElement, _ref) {
    let {
      data,
      props,
      children
    } = _ref;
    props = {
      placeholder: props.placeholder,
      placeholderTag: props.tag
    };
    return createElement("client-only", {
      ...data,
      props
    }, children);
  }
};